import { useCallback as r, useEffect as a } from "preact/hooks";
const c = ({ event: s, callback: o }) => {
  const e = (n) => {
    const t = n.detail;
    o(t);
  };
  return window.addEventListener(`@nosto/search-js/${s}`, e), () => {
    window.removeEventListener(`@nosto/search-js/${s}`, e);
  };
}, d = ({ event: s, callback: o }) => {
  const e = r(
    (n) => {
      const t = n.detail;
      o(t);
    },
    [o]
  );
  a(() => (window.addEventListener(`@nosto/search-js/${s}`, e), () => {
    window.removeEventListener(`@nosto/search-js/${s}`, e);
  }), [s, e]);
};
export {
  c as s,
  d as u
};
